/**
 * Blog listing image skeleton: keep shimmer until the lazy image is painted.
 *
 * @param {ParentNode} [root=document]
 */
export function initBlogListing(root = document) {
  const figures = root.querySelectorAll('.blog-listing__image:not([data-image-loaded="1"])');

  figures.forEach((figure) => {
    if (!(figure instanceof HTMLElement)) {
      return;
    }

    const image = figure.querySelector('img');
    if (!(image instanceof HTMLImageElement)) {
      figure.dataset.imageLoaded = '1';
      return;
    }

    const markLoaded = () => {
      figure.dataset.imageLoaded = '1';
    };

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
      return;
    }

    image.addEventListener('load', markLoaded, { once: true });
    image.addEventListener('error', markLoaded, { once: true });

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
    }
  });
}
